import { GoAButton, GoAIcon, GoASpacer } from '@abgov/react-components';
import { useNavigate } from 'react-router-dom';
import {
  isAdmin,
  isLawEnforcementAdmin,
  isLawEnforcementOfficer,
} from '../../state/slices/authSlice';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import { albertaCaConfig, goaConfig, lawConfig } from '../../utils/oidcConfig';
import { useAuth } from 'react-oidc-context';

const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

export const TokenExpiryComponent = () => {
  const navigate = useNavigate();
  const { signinRedirect } = useAuth();

  const stateAuth = useAppSelector((state: RootState) => state.auth);
  return (
    <div
      style={{
        margin: '0',
        padding: '0',
        maxWidth: 'none',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        className="error-component"
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          width: '600px',
        }}
      >
        <GoASpacer vSpacing="xl" />

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '120px',
            height: '120px',
            borderRadius: '60px',
            backgroundColor: 'var(--Color-Greyscale-100, #F1F1F1)',
          }}
        >
          <ion-icon
            name="car-sport-outline"
            style={{
              fontSize: '5rem',
              paddingTop: '1rem',
            }}
          ></ion-icon>{' '}
        </div>
        <GoASpacer vSpacing="xl" />

        <div
          style={{
            width: '110px',
            height: '8px',
            backgroundColor: 'var(--goa-color-brand-default)',
          }}
        >
          {' '}
        </div>

        <div style={{ width: '400px' }}>
          <h2>Your Report My Collision session has expired</h2>
        </div>
        <GoASpacer vSpacing="xl" />
        <div>
          Your session has expired due to inactivity. Please log back in if you
          want to continue your collision report
        </div>
        <GoASpacer vSpacing="xl" />
        <GoAButton
          onClick={() => {
            if (
              isLawEnforcementOfficer(stateAuth) ||
              isLawEnforcementAdmin(stateAuth)
            ) {
              signinRedirect({
                ...lawConfig,
              });
            } else if (isAdmin(stateAuth)) {
              signinRedirect({
                ...goaConfig,
              });
            } else {
              signinRedirect({
                ...albertaCaConfig,
              });
            }
          }}
        >
          Login
        </GoAButton>
      </div>
    </div>
  );
};
